import { BaseEntity } from '../../xform-compat';
import { MyCompanyBasic } from './my-company-basic.model';


export class MyCompany implements BaseEntity {
  id: number;
  companyId: number;
  name: string;
  created: string;
  company: MyCompanyBasic;
  companyIds?: Array<number>;
}
